/**
 * Created by linjianxi on 2016/11/10.
 */
import * as actions from './actions'
import * as getters from './getter'
import * as types from './mutation-type'
const state = {
  payList: {},
  payResult: {},
  aliPayHtml: '',
  userInfo: {},
  codeImg: '',
  isShow: true // 显示验证码
 // isUser: false, // 显示用户信息
 // isEnter: true // 显示输入浪客号
}
const mutations = {
  [types.WECHART_PAY] (state, result) {
    state.payResult = result
  },
  [types.PAY_LIST] (state, result) {
    state.payList = result
  },
  [types.USER_INFOR] (state, result) {
    state.userInfo = result
   // state.isUser = true
   // state.isEnter = false
  },
  [types.GET_CODE_IMG] (state, result) {
    state.isShow = true
    state.codeImg = result
  },
  [types.SWITCH_USER] (state) {
   // state.isUser = false
   // state.isEnter = true
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/pay_test/store.js